Modal = require 'components/common/modal'
ExportDialog = require 'components/common/export_dialog'
{ useI18n } = require 'lib/react_utils'

outputFormats = ['pdf', 'external_link', 'external_embeddable_code']

ExportModal = ({ onClose, onExport, isOpen, url, exportIsDone }) ->

  i18n = useI18n('vi:export')

  <Modal
    isOpen={isOpen}
    className="vi-guidelines-export-modal"
    closeButton={true}
    title={i18n 'title'}
  >
    <div>
      <ExportDialog
        exportIsDone={exportIsDone}
        outputFormats={outputFormats}
        onClose={onClose}
        url={url}
        onDownload={onExport}
      />
    </div>
  </Modal>

module.exports = ExportModal
